import { Education } from '../types';

export const education: Education[] = [
    {
        degree: 'Imagine Fellowship — Career Coaching & Development',
        institution: 'Imagine Foundation e.V.',
        duration: 'July 2024 – October 2024',
    },
    {
        degree: 'Bachelor of Information Engineering',
        institution: 'Al-Baath University',
        duration: 'September 2015 – October 2020',
    }
];
